import Select from '../components/Select';
import { events } from '../utils/';

const intra = {
  init() {
    this.page = document.querySelector('.intraPage');
    if (!this.page) return;
    this.createSelect();
    this.bindEvents();
  },

  createSelect() {
    this.select = new Select({
      source: '.js-select-source-intra',
      caption: '.js-select-caption-intra',
      config: {
        initialValue: this.page.dataset.initialnav,
        type: 'intra',
      },
    });
  },

  bindEvents() {
    events.on('select', e => this.handleSelect(e));
  },

  handleSelect({ value, type }) {
    if (type !== 'intra') return;
    window.location.href = value;
  },
};

export default intra.init();



// WEBPACK FOOTER //
// ./pages/intra.js